import React from "react";

const Errors = ({ error }) => {
  return <div className="flex justify-center flex-col items-center z-30 text-pink-500 font-bold">{error.message}</div>;
};

export default Errors;
